import React from 'react';
import Form, { Actions } from '../../../Components/Form';
import Icon from '../../../Components/Icons/Icon';

const CompromisedPasswordChallenge = ({ onSubmit }) => {
    return <Form data={{acknowledged: true}} onSubmit={onSubmit}>
        <div className="flex gap-3">
            <Icon icon="TriangleExclamation" className="fill-amber-600 shrink-0 mt-1" size="2x" />
            <div>
                <h2 className="font-semibold mb-2">This password has appeared in known data breaches</h2>
                <p className="text-sm text-muted mb-3">
                    Your password matches one in Have I Been Pwned's database of passwords exposed in breaches of other services.
                    <br />
                    getSoapy has not had a security incident.
                </p>
                <p className="text-sm text-muted mb-3">
                    We did not send your password to Have I Been Pwned. We checked it using a privacy-preserving partial hash.
                </p>
                <p className="text-sm text-muted mb-3">
                    Please change this password in getSoapy after signing in, and anywhere else you use it.
                </p>
                <a
                    href="https://haveibeenpwned.com/Passwords"
                    target="_blank"
                    className="link text-sm"
                    rel="noreferrer"
                >
                    Learn more about Pwned Passwords
                </a>
            </div>
        </div>
        <Actions submit={{label: 'Continue'}} />
    </Form>;
};

export default CompromisedPasswordChallenge;
